export default __webpack_public_path__ + "static/media/td_logo_v1.76a5fca3.svg";